import { pointHistoryResource, PointHistoryResource } from '@witkac/kartamiejska-resources';
import { PointHistory } from '@witkac/kartamiejska-shared';

import { EntityListModule } from './entityList.module';

/**
 * Moduł historii punktów
 *
 * @class PointHistoryModule
 * @extends {EntityListModule<PointHistory, PointHistoryResource>}
 */
class PointHistoryModule extends EntityListModule<PointHistory, PointHistoryResource> {}

export default new PointHistoryModule(pointHistoryResource);
